import React from "react";
import Status from "../../../../model2/status/status";

type Props = {
    className?: string,
    status: Status
}

// BE CAREFULL USED IN MULTIPLE PLACES !!!! like my work

export default function TaskStatusSelector_UI5(props: Props) {

    const curValueClasses = Classes('ui5-status-list', 'status-c{0}'.f(props.status.color), props.className, {
        // 's18': this.props.renderValue === 'ui5-18',
        // 's22': this.props.renderValue === 'ui5-22'
    });
    return (
        <div className={curValueClasses}>
            {props.status.name}
        </div>
    );
}
